export default "__VITE_ASSET__CNG1085b__"